import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import styles from './TableHeader.module.css';

type Props = {
  textTKey: string;
  field?: string;
  unit?: string;
  icon?: React.ReactNode;
  tableSubHeader?: boolean;
};

export const TableHeader = observer<Props>(function TableHeader({ textTKey, unit, icon, tableSubHeader }) {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper} title={`${t(textTKey)}`}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <h4 className={clsx(styles.header, tableSubHeader && styles.tableSubHeader)}>
        {`${t(textTKey)}${unit ? ', ' : ''}`}
      </h4>
      {unit && <p className={styles.unit}>{unit}</p>}
    </div>
  );
});
